import React from "react";
import { Skeleton, Typography } from "@picklebet/ui";
import { constructCurrency } from "common/currency";
import { SupportLink } from "@/features/shell/components/shared/SupportLink";
import { useGameSessions } from "@/features/casino/hooks/useGameSessions";
import { useWithdrawWizard } from "@/features/wallet/components/withdraw/hooks/useWithdrawWizard";

import * as styles from "./WithdrawableBalance.module.scss";

export const WithdrawableBalanceSkeleton = () => (
  <div className={styles.container}>
    <Skeleton size="xs" span="third" className={styles.skeleton} edge="hard" />
    <Skeleton size="xs" span="quart" className={styles.skeleton} edge="hard" />
  </div>
);

export const WithdrawableBalance = () => {
  const { currency, withdrawableAmountInCents } = useWithdrawWizard();
  const { hasActiveGameSession, isLoading } = useGameSessions(true);

  return (
    <div className={styles.container}>
      <Typography
        className={styles.label}
        noSpacing
        skeleton={{ loading: isLoading }}
      >
        Withdrawable balance:{" "}
        {hasActiveGameSession
          ? "In Play"
          : `${constructCurrency(withdrawableAmountInCents, {
              currencyType: currency,
            })}`}
      </Typography>

      <SupportLink
        hideChevron
        options={{ labels: ["weblink-turnover-requirements"] }}
        className={styles.supportLink}
      >
        Learn Why
      </SupportLink>
    </div>
  );
};
